/**
 * Analytics for audio player component. What do we have here:
 *   - Listener for playPause method. Everytime the user start playing, we send an event.
 */
import Analytics from '@module/analytics';

export const actions = {};

export const states = {};

const audioFiles = {};
export const methods = {
  playPause() {
    // We want to send this event only once, when the user clicks the first time on play button.
    // Since it's a ply/pause button, we need a guard
    const fileId = this.route.params.file_id;
    if (audioFiles[fileId] && audioFiles[fileId].played) {
      return;
    }

    // State is injected by Analytics component
    const items = this.transfer.items || [];
    const item = items.find((item) => item.id === fileId) || {};
    const payload = {
      category: 'preview page',
      action: 'preview audio played',
      label: `Item ${item.id}`,
      item: {
        id: fileId,
        previewable: item.previewable,
      },
    };
    Analytics.pushDataLayerEvent(payload);
    audioFiles[fileId] = {
      played: true,
    };
  },
};
